(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-video-hero"]) return;
  try {
    
const video = document.querySelector("video.banner-video");

function addSourceToVideo(element, src) {
  let source = document.createElement("source");
  source.src = src;
  source.type = "video/mp4"; 
  element.appendChild(source);
}

function whichSizeVideo(element) {
  let windowWidth = window.innerWidth;
  if (windowWidth > 500) {
    addSourceToVideo(element, element.dataset.desktopVid);
  } else {
    addSourceToVideo(element, element.dataset.mobileVid);
  }
}

function videoSize(element) {
  if (video !== undefined) {
    whichSizeVideo(
        element
    );
  }
}

videoSize(video); 

  } catch(e) { console.error(e); }
})();
})();
